import { Grid, Typography, useTheme } from "@mui/material";
import { GridRowIdGetter, GridRowModel } from "@mui/x-data-grid-pro";
import React, { useMemo } from "react";
import { useTranslations } from "@fenetech/translations";
import { ISearchResult, SearchTypeEnum } from "./Search";

import CustomDataGridPro from "components/Common/CustomDataGridPro";
import DataGridColumnGenerator from "components/Common/DataGridColumnGenerator";
import useIsMobile from "helpers/hooks/useIsMobile";

interface IProps {
    results: ISearchResult[];
    searchType: SearchTypeEnum;
}

const SearchGrid: React.FC<IProps> = ({results, searchType}: IProps) => {

    const tm = useTranslations();
    const theme = useTheme();
    const isMobile = useIsMobile();

    const columns = useMemo(() => {
        const generator = new DataGridColumnGenerator(tm, results, theme, isMobile);

        const uri = searchType === SearchTypeEnum.Quote ? "/quotes" : "/orders";
        generator.TryAddDocumentNumberColumn('key', 'documentNumber', SearchTypeEnum[searchType], uri, {hideable: false})
        generator.TryAddDateColumn("orderDate", "Date",{});
        generator.TryAddTextColumn("customerName", "Customer",{});
        generator.TryAddTextColumn("poNumber", "PO Number",{});
        generator.TryAddTextColumn("customerRef", "Customer Ref", {});
        
        return generator.GetColumns();
    }, [tm, theme, isMobile, results, searchType]);

    if (results.length === 0)
        return <>
            <Grid container>
                <Grid item textAlign="center">
                    <Typography variant="h4">{tm.Get("No results were found.")}</Typography>
                </Grid>
            </Grid>
        </>
    else {

        const getRowId: GridRowIdGetter = (row: GridRowModel) => {
            return row.key;
        }

        return <CustomDataGridPro
            getRowId={getRowId}
            rows={results}
            columns={columns}
            tableName="SearchGrid"
            tableSubName={isMobile ? "Mobile" : ""}
        />;
    }
}


export default SearchGrid;